/* eslint import/no-unresolved: 0 */
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SequenceDueDate from '@src/course-home/outline-tab/section-outline/SequenceDueDate';
import HiddenSequenceLink from '@src/course-home/outline-tab/section-outline/HiddenSequenceLink';
import SequenceHeader from './SequenceHeader';
import { UNLOCKED } from './constants';

const SequenceLink = ({
  id,
  first,
  sequence,
  sequenceData,
}) => {
  const {
    complete,
    description,
    due,
    showLink,
    title,
    hideFromTOC,
  } = sequence;

  const lockedStatus = sequenceData[id];
  const isLocked = lockedStatus !== UNLOCKED;

  return (
    <li>
      <div className={classNames('px-3 py-2', { 'border-top border-light': !first }, { 'bg-primary-100': isLocked })}>
        <SequenceHeader
          {...{
            complete,
            id,
            lockedStatus,
            sequence,
            showLink,
            title,
          }}
        />
        {hideFromTOC && (
          <HiddenSequenceLink />
        )}
        <SequenceDueDate {...{ due, id, description }} />
      </div>
    </li>
  );
};

SequenceLink.propTypes = {
  id: PropTypes.string.isRequired,
  first: PropTypes.bool.isRequired,
  sequence: PropTypes.shape().isRequired,
  sequenceData: PropTypes.shape().isRequired,
};

export default SequenceLink;
